export const pathQueryParams = {
  /** tid of the prefill in `foodTemplateStorage` */
  template: 'template',
} as const;
